import VueI18n from 'vue-i18n'
import Vue from 'vue'
import zh from './zh.json'
import en from './en.json'

Vue.use(VueI18n)

const locale = localStorage.getItem('locale') || 'zh'

export default new VueI18n({
	locale: locale,
	messages: {
		zh,
		en
	}
})
